// Cloud Run service configuration
export const CLOUD_RUN_CONFIG = {
  // Video processor service URL
  // For local dev: http://localhost:8081
  // For production: https://video-processor-XXXX-uc.a.run.app
  VIDEO_PROCESSOR_URL: import.meta.env.VITE_VIDEO_PROCESSOR_URL || 'http://localhost:8086',
};

// Helper function to check if we should use Cloud Run
// Use Cloud Run when the URL is configured (both local and production)
// export const shouldUseCloudRun = () => {
//   return !!CLOUD_RUN_CONFIG.VIDEO_PROCESSOR_URL;
// };
